import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Output, Input, NgModule } from '@angular/core';
import * as i3 from 'base-letter-template-library';
import { BaseLetterTemplateLibraryService } from 'base-letter-template-library';
import * as i1 from '@ngrx/store';
import * as i2 from 'ngx-toastr';
import * as i4 from '@angular/common';
import * as i5 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i6 from 'primeng/table';
import * as i7 from 'primeng/api';
import * as i8 from 'primeng/paginator';
import * as i9 from 'primeng/button';
import * as i10 from 'primeng/radiobutton';
import * as i11 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i12 from '@progress/kendo-angular-toolbar';
import * as i13 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { DigitalSignatureLibraryModule } from 'digital-signature-library';

class LetterTemplateLibraryService {
    constructor() { }
}
LetterTemplateLibraryService.ɵfac = function LetterTemplateLibraryService_Factory(t) { return new (t || LetterTemplateLibraryService)(); };
LetterTemplateLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: LetterTemplateLibraryService, factory: LetterTemplateLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterTemplateLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["lettertemplateupload"];
const _c1 = ["lettertemplatekendoeditor"];
const _c2 = ["letterTemplateForm"];
function LetterTemplateLibraryComponent_u_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "u", 12);
    i0.ɵɵlistener("click", function LetterTemplateLibraryComponent_u_1_Template_u_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.handleBack(); });
    i0.ɵɵelementStart(1, "span", 13);
    i0.ɵɵtext(2, " arrow_back_ios ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "Create Own Letter ");
    i0.ɵɵelementEnd();
} }
function LetterTemplateLibraryComponent_ng_template_10_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r9 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", col_r9.header, " ");
} }
function LetterTemplateLibraryComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 14);
    i0.ɵɵelement(1, "th", 15);
    i0.ɵɵtemplate(2, LetterTemplateLibraryComponent_ng_template_10_th_2_Template, 2, 1, "th", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", columns_r7);
} }
function LetterTemplateLibraryComponent_ng_template_11_td_3_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r14 = i0.ɵɵnextContext().$implicit;
    const listData_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", listData_r10[col_r14.field], " ");
} }
function LetterTemplateLibraryComponent_ng_template_11_td_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listData_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", listData_r10["templateName"], " ");
} }
function LetterTemplateLibraryComponent_ng_template_11_td_3_span_3_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 26);
    i0.ɵɵtext(1, " Default ");
    i0.ɵɵelementEnd();
} }
function LetterTemplateLibraryComponent_ng_template_11_td_3_span_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1, " Last Used ");
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3, "Template ");
    i0.ɵɵelementEnd();
} }
function LetterTemplateLibraryComponent_ng_template_11_td_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtemplate(1, LetterTemplateLibraryComponent_ng_template_11_td_3_span_3_p_1_Template, 2, 0, "p", 24);
    i0.ɵɵtemplate(2, LetterTemplateLibraryComponent_ng_template_11_td_3_span_3_span_2_Template, 4, 0, "span", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r14 = i0.ɵɵnextContext().$implicit;
    const listData_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", listData_r10[col_r14.field] === "true");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", listData_r10["id"] === ctx_r17.lastUsedTemplateId && ctx_r17.isOwnTemplateUsed);
} }
function LetterTemplateLibraryComponent_ng_template_11_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 20);
    i0.ɵɵtemplate(1, LetterTemplateLibraryComponent_ng_template_11_td_3_span_1_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(2, LetterTemplateLibraryComponent_ng_template_11_td_3_span_2_Template, 3, 1, "span", 21);
    i0.ɵɵtemplate(3, LetterTemplateLibraryComponent_ng_template_11_td_3_span_3_Template, 3, 2, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r14 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r14.field != "isDefault" && col_r14.field !== "templateName");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r14.field === "templateName");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r14.field == "isDefault");
} }
function LetterTemplateLibraryComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 17);
    i0.ɵɵelement(2, "button", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LetterTemplateLibraryComponent_ng_template_11_td_3_Template, 4, 3, "td", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listData_r10 = ctx.$implicit;
    const expanded_r11 = ctx.expanded;
    const columns_r12 = ctx.columns;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pRowToggler", listData_r10)("icon", expanded_r11 ? "pi pi-chevron-down" : "pi pi-chevron-right");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r12);
} }
function LetterTemplateLibraryComponent_ng_template_12_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelementStart(1, "button", 43);
    i0.ɵɵlistener("click", function LetterTemplateLibraryComponent_ng_template_12_div_17_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(2); return ctx_r28.handleSavePreview("Preview"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r26.disabledControls);
} }
function LetterTemplateLibraryComponent_ng_template_12_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelementStart(1, "p", 45);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "small", 46);
    i0.ɵɵtext(4, "(placeholder added when creating this template)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "kendo-editor", 47, 48);
    i0.ɵɵlistener("valueChange", function LetterTemplateLibraryComponent_ng_template_12_div_18_Template_kendo_editor_valueChange_5_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.letterTextContent = $event; })("valueChange", function LetterTemplateLibraryComponent_ng_template_12_div_18_Template_kendo_editor_valueChange_5_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.letterTextContenteditorValueChange($event); });
    i0.ɵɵelementStart(7, "kendo-toolbar");
    i0.ɵɵelementStart(8, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(9, "kendo-toolbar-button", 49);
    i0.ɵɵelement(10, "kendo-toolbar-button", 50);
    i0.ɵɵelement(11, "kendo-toolbar-button", 51);
    i0.ɵɵelement(12, "kendo-toolbar-button", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(14, "kendo-toolbar-button", 53);
    i0.ɵɵelement(15, "kendo-toolbar-button", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(17, "kendo-toolbar-button", 55);
    i0.ɵɵelement(18, "kendo-toolbar-button", 56);
    i0.ɵɵelement(19, "kendo-toolbar-button", 57);
    i0.ɵɵelement(20, "kendo-toolbar-button", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "kendo-toolbar-dropdownlist", 59);
    i0.ɵɵelement(22, "kendo-toolbar-dropdownlist", 60);
    i0.ɵɵelement(23, "kendo-toolbar-dropdownlist", 61);
    i0.ɵɵelement(24, "kendo-toolbar-colorpicker", 62);
    i0.ɵɵelement(25, "kendo-toolbar-colorpicker", 63);
    i0.ɵɵelementStart(26, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(27, "kendo-toolbar-button", 64);
    i0.ɵɵelement(28, "kendo-toolbar-button", 65);
    i0.ɵɵelement(29, "kendo-toolbar-button", 66);
    i0.ɵɵelement(30, "kendo-toolbar-button", 67);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(31, "kendo-toolbar-button", 68);
    i0.ɵɵelement(32, "kendo-toolbar-button", 69);
    i0.ɵɵelementStart(33, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(34, "kendo-toolbar-button", 70);
    i0.ɵɵelement(35, "kendo-toolbar-button", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(37, "kendo-toolbar-button", 72);
    i0.ɵɵelement(38, "kendo-toolbar-button", 73);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(39, "kendo-toolbar-button", 74);
    i0.ɵɵelement(40, "kendo-toolbar-button", 75);
    i0.ɵɵelement(41, "kendo-toolbar-button", 76);
    i0.ɵɵelement(42, "kendo-editor-insert-table-button");
    i0.ɵɵelementStart(43, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(44, "kendo-toolbar-button", 77);
    i0.ɵɵelement(45, "kendo-toolbar-button", 78);
    i0.ɵɵelement(46, "kendo-toolbar-button", 79);
    i0.ɵɵelement(47, "kendo-toolbar-button", 80);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(49, "kendo-toolbar-button", 81);
    i0.ɵɵelement(50, "kendo-toolbar-button", 82);
    i0.ɵɵelement(51, "kendo-toolbar-button", 83);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(53, "kendo-toolbar-button", 84);
    i0.ɵɵelement(54, "kendo-toolbar-button", 85);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(55, "kendo-toolbar-button", 86);
    i0.ɵɵelementStart(56, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(57, "kendo-toolbar-button", 87);
    i0.ɵɵelementStart(58, "kendo-toolbar-button", 88);
    i0.ɵɵlistener("click", function LetterTemplateLibraryComponent_ng_template_12_div_18_Template_kendo_toolbar_button_click_58_listener() { i0.ɵɵrestoreView(_r33); const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.lettertemplateimageuploaddialog(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(59, "app-upload-image-dialog", 89, 90);
    i0.ɵɵelementStart(61, "div", 91);
    i0.ɵɵelementStart(62, "div", 92);
    i0.ɵɵelementStart(63, "button", 93);
    i0.ɵɵlistener("click", function LetterTemplateLibraryComponent_ng_template_12_div_18_Template_button_click_63_listener() { i0.ɵɵrestoreView(_r33); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.handleSavePreview("Save"); });
    i0.ɵɵtext(64, "SAVE & PREVIEW");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(65, "div");
    i0.ɵɵelementStart(66, "button", 93);
    i0.ɵɵlistener("click", function LetterTemplateLibraryComponent_ng_template_12_div_18_Template_button_click_66_listener() { i0.ɵɵrestoreView(_r33); const ctx_r37 = i0.ɵɵnextContext(2); return ctx_r37.handleSavePreview("Skip"); });
    i0.ɵɵtext(67, "SKIP & PREVIEW");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r30 = i0.ɵɵreference(6);
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Add Additional Info for ", ctx_r27.letterType === "COVLTR" ? "Cover Letter" : "Support Letter", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r27.letterTextContent);
    i0.ɵɵadvance(54);
    i0.ɵɵproperty("editor", _r30);
} }
function LetterTemplateLibraryComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵelementStart(4, "h6", 31);
    i0.ɵɵtext(5, "Template Name - ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 32);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 33);
    i0.ɵɵelementStart(9, "div", 34);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 35);
    i0.ɵɵelementStart(12, "div", 36);
    i0.ɵɵlistener("change", function LetterTemplateLibraryComponent_ng_template_12_Template_div_change_12_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(); return ctx_r38.handleToggle($event); });
    i0.ɵɵelementStart(13, "p-radioButton", 37);
    i0.ɵɵlistener("ngModelChange", function LetterTemplateLibraryComponent_ng_template_12_Template_p_radioButton_ngModelChange_13_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.additionalInfo = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "p-radioButton", 38);
    i0.ɵɵlistener("ngModelChange", function LetterTemplateLibraryComponent_ng_template_12_Template_p_radioButton_ngModelChange_14_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.additionalInfo = $event; });
    i0.ɵɵelementStart(15, "label", 39);
    i0.ɵɵtext(16, "No");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, LetterTemplateLibraryComponent_ng_template_12_div_17_Template, 2, 1, "div", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, LetterTemplateLibraryComponent_ng_template_12_div_18_Template, 68, 3, "div", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listData_r25 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", listData_r25["templateName"], "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Did you select 'Additional Info for ", ctx_r4.letterType === "COVLTR" ? "Cover Letter" : "Support Letter", "' in placeholder while creating the template? ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r4.additionalInfo)("disabled", ctx_r4.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r4.additionalInfo)("disabled", ctx_r4.disabledControls);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.additionalInfo === "No");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.additionalInfo === "Yes");
} }
const _c3 = function () { return [25, 50, 100]; };
class LetterTemplateLibraryComponent extends BaseLetterTemplateLibraryService {
    constructor(store, toastr, apiService) {
        super(store, toastr, apiService);
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.onDialogClose = new EventEmitter();
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        this.docType = sessionStorage.getItem('typeOfLetter');
        super.loadInit();
    }
    ngAfterViewInit() {
        this.letterTemplateForm = this.letterTemplateForm;
        super.loadAfterViewInit();
    }
    lettertemplateimageuploaddialog() {
        this.lettertemplateupload.open();
    }
    letterTextContenteditorValueChange(value) {
        this.letterTextContent = value;
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.loadDestroy();
    }
}
LetterTemplateLibraryComponent.ɵfac = function LetterTemplateLibraryComponent_Factory(t) { return new (t || LetterTemplateLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i3.APILetterTemplate)); };
LetterTemplateLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LetterTemplateLibraryComponent, selectors: [["letter-template-library"]], viewQuery: function LetterTemplateLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 1);
        i0.ɵɵviewQuery(_c2, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.lettertemplateupload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.lettertemplatekendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.letterTemplateForm = _t.first);
    } }, inputs: { primaryData: "primaryData" }, outputs: { lettertemplatekendoeditor: "lettertemplatekendoeditor", onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 14, vars: 6, consts: [[1, "col-md-9", "pl-0", "row", "d-flex", "align-items-center", "mb-2", 2, "cursor", "pointer", "color", "rgb(75, 197, 238)"], ["class", "heading", 3, "click", 4, "ngIf"], [1, "row", "col-md-12", "p-0"], [1, "letter-hint", "d-flex", "align-items-center"], [1, "pi", "pi-exclamation-triangle", 2, "padding-top", "3px"], [1, "letter-list"], ["letterTemplateForm", "ngForm"], ["styleClass", "p-datatable-gridlines", "dataKey", "id", 1, "pa-table", "im-card-no-border-table", "im-card-table-noborder-spacing", "table", "table-striped-simple", 3, "columns", "value", "onRowExpand"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "rowexpansion"], [3, "rows", "rowsPerPageOptions", "onPageChange"], [1, "heading", 3, "click"], [1, "material-icons", "align-middle", 2, "font-size", "inherit"], [1, "text-uppercase"], [2, "width", "2rem"], [4, "ngFor", "ngForOf"], [2, "padding", "10px 0px !important"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-button-text", "p-button-rounded", "p-button-plain", 3, "pRowToggler", "icon"], ["class", "text-truncate", 4, "ngFor", "ngForOf"], [1, "text-truncate"], [4, "ngIf"], ["class", "column.customClass default-btn", 4, "ngIf"], [1, "column.customClass", "default-btn"], ["class", "m-0", 4, "ngIf"], ["class", "column.customClass last-text", 4, "ngIf"], [1, "m-0"], [1, "column.customClass", "last-text"], ["colspan", "7"], [1, "sub-task-type", "pb-3"], [1, "row", "col-md-12"], [1, "label-cls"], [1, "row", "pl-1"], [1, "row", "col-md-12", "d-flex", "align-items-center"], [1, "col-md-7", "my-2", "p-0", "expand-text"], [1, "col-md-3", "p-0", "pl-1"], ["aria-labelledby", "example-radio-group-label", 1, "example-radio-group", 3, "change"], ["name", "additionalInfo", "value", "Yes", "label", "Yes", 1, "pr-4", 3, "ngModel", "disabled", "ngModelChange"], ["value", "No", "name", "additionalInfo", "label", "No", 1, "example-radio-button", 3, "ngModel", "disabled", "ngModelChange"], ["for", "No"], ["class", "col-md-2 preview-btn p-0", 4, "ngIf"], ["class", "col-12 pt-3  letter-textarea", 4, "ngIf"], [1, "col-md-2", "preview-btn", "p-0"], ["pButton", "", "label", "PREVIEW", "type", "button", 1, "p-button-outlined", 2, "width", "100%", 3, "disabled", "click"], [1, "col-12", "pt-3", "letter-textarea"], [1, "pb-3", "mb-0", "one-liner", "expand-text"], [2, "font-size", "13px"], ["name", "letterTextContent", 2, "height", "400px", 3, "value", "valueChange"], ["lettertemplatekendoeditor", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["title", "Upload\u2019s Image at cursor point", "text", "Upload Image", 3, "click"], [3, "editor"], ["lettertemplateupload", ""], [1, "d-flex", "py-2", "pt-3"], [1, "mr-3"], ["type", "button", "pButton", "", 1, "p-button-info", 3, "click"]], template: function LetterTemplateLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, LetterTemplateLibraryComponent_u_1_Template, 4, 0, "u", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "p", 3);
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵtext(5, " If you have modified a template you have used, click \u201CGenerate Letter\u201D again to sync all changes. ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "form", null, 6);
        i0.ɵɵelementStart(9, "p-table", 7);
        i0.ɵɵlistener("onRowExpand", function LetterTemplateLibraryComponent_Template_p_table_onRowExpand_9_listener($event) { return ctx.onRowExpand($event); });
        i0.ɵɵtemplate(10, LetterTemplateLibraryComponent_ng_template_10_Template, 3, 1, "ng-template", 8);
        i0.ɵɵtemplate(11, LetterTemplateLibraryComponent_ng_template_11_Template, 4, 3, "ng-template", 9);
        i0.ɵɵtemplate(12, LetterTemplateLibraryComponent_ng_template_12_Template, 19, 8, "ng-template", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "p-paginator", 11);
        i0.ɵɵlistener("onPageChange", function LetterTemplateLibraryComponent_Template_p_paginator_onPageChange_13_listener($event) { return ctx.handlePageSettingsChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.letterType === "COVLTR");
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("columns", ctx.listTemplateColumns)("value", ctx.templateList);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("rows", ctx.recordsPerPage)("rowsPerPageOptions", i0.ɵɵpureFunction0(5, _c3));
    } }, directives: [i4.NgIf, i5.ɵangular_packages_forms_forms_ba, i5.NgControlStatusGroup, i5.NgForm, i6.Table, i7.PrimeTemplate, i8.Paginator, i4.NgForOf, i9.ButtonDirective, i6.RowToggler, i10.RadioButton, i5.NgControlStatus, i5.NgModel, i11.EditorComponent, i12.ToolBarComponent, i12.ToolBarButtonGroupComponent, i12.ToolBarButtonComponent, i11.EditorBoldButtonDirective, i11.EditorItalicButtonDirective, i11.EditorUnderlineButtonDirective, i11.EditorStrikethroughButtonDirective, i11.EditorSubscriptButtonDirective, i11.EditorSuperscriptButtonDirective, i11.EditorAlignLeftButtonDirective, i11.EditorAlignCenterButtonDirective, i11.EditorAlignRightButtonDirective, i11.EditorAlignJustifyButtonDirective, i11.EditorFormatComponent, i11.EditorFontSizeComponent, i11.EditorFontFamilyComponent, i11.EditorColorPickerComponent, i11.EditorForeColorDirective, i11.EditorBackColorDirective, i11.EditorInsertUnorderedListButtonDirective, i11.EditorInsertOrderedListButtonDirective, i11.EditorIndentButtonDirective, i11.EditorOutdentButtonDirective, i11.EditorBlockquoteDirective, i11.EditorSelectAllButtonDirective, i11.EditorUndoButtonDirective, i11.EditorRedoButtonDirective, i11.EditorCreateLinkButtonDirective, i11.EditorUnlinkButtonDirective, i11.EditorInsertFileButtonDirective, i11.EditorViewSourceButtonDirective, i11.EditorCleanFormattingButtonDirective, i11.EditorInsertTableButtonComponent, i11.EditorAddColumnBeforeButtonDirective, i11.EditorAddColumnAfterButtonDirective, i11.EditorAddRowBeforeButtonDirective, i11.EditorAddRowAfterButtonDirective, i11.EditorDeleteColumnButtonDirective, i11.EditorDeleteRowButtonDirective, i11.EditorDeleteTableButtonDirective, i11.EditorMergeCellsButtonDirective, i11.EditorSplitCellButtonDirective, i11.EditorPrintDirective, i11.EditorInsertImageButtonDirective, i13.UploadImageDialogComponent], styles: [".template-list[_ngcontent-%COMP%]{width:100%}.template-list[_ngcontent-%COMP%]   .mat-header-row[_ngcontent-%COMP%]{background:#f5f7f7!important}.template-list[_ngcontent-%COMP%]   .mat-header-row[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#5a5a5a!important;font-size:13px;font-weight:600!important}.template-list[_ngcontent-%COMP%]   .example-element-row[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-bottom-width:0;font-size:13px}.template-list[_ngcontent-%COMP%]   .example-element-row[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .last-text[_ngcontent-%COMP%]{color:#57afe0!important;font-size:13px!important;padding:10px 0!important}.template-list[_ngcontent-%COMP%]   .expand-text[_ngcontent-%COMP%]{font-size:14px}.mat-form-field[_ngcontent-%COMP%]{font-size:14px;width:100%}tr.example-detail-row[_ngcontent-%COMP%]{height:0}tr.example-element-row[_ngcontent-%COMP%]:not(.example-expanded-row):hover{background:#f5f5f5}tr.example-element-row[_ngcontent-%COMP%]:not(.example-expanded-row):active{background:#efefef}.example-element-detail[_ngcontent-%COMP%]{overflow:hidden;display:flex}.example-element-diagram[_ngcontent-%COMP%]{min-width:80px;border:2px solid #000;padding:8px;font-weight:lighter;margin:8px 0;height:104px}.example-element-symbol[_ngcontent-%COMP%]{font-weight:700;font-size:40px;line-height:normal}.example-element-description[_ngcontent-%COMP%]{padding:16px}.example-element-description-attribution[_ngcontent-%COMP%]{opacity:.5}.letter-hint[_ngcontent-%COMP%]{color:#b56918;font-size:13px}.letter-hint[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-right:10px;padding-top:3px;font-size:20px}.pa-table[_ngcontent-%COMP%]{border-bottom:2px solid #dee2e6}.pa-table[_ngcontent-%COMP%]   .expandIcon[_ngcontent-%COMP%]{padding:10px 5px 5px!important}.pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;padding:15px!important;color:#4d4f5c;font-style:normal;font-variant:normal;font-weight:700;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{color:#4a4a4a;border-top:none!important;padding:20px 15px 0!important;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:6px 8px!important;font-size:14px}.pa-table[_ngcontent-%COMP%]   .courseList[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#495057}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#4d4f5c;font-weight:700;font-size:13px}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{font-size:13px}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   .duty-list[_ngcontent-%COMP%]{color:#888;font-size:13px}.default-btn[_ngcontent-%COMP%]{color:#b56918;font-weight:500}.label-cls[_ngcontent-%COMP%]{color:#626262;font-size:14px;font-weight:600}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterTemplateLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'letter-template-library',
                templateUrl: 'letter-template-library.component.html',
                styleUrls: ['letter-template-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.ToastrService }, { type: i3.APILetterTemplate }]; }, { lettertemplateupload: [{
            type: ViewChild,
            args: ["lettertemplateupload"]
        }], lettertemplatekendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["lettertemplatekendoeditor"]
        }], primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], letterTemplateForm: [{
            type: ViewChild,
            args: ['letterTemplateForm', { static: false }]
        }] }); })();

class LetterTemplateLibraryModule {
}
LetterTemplateLibraryModule.ɵfac = function LetterTemplateLibraryModule_Factory(t) { return new (t || LetterTemplateLibraryModule)(); };
LetterTemplateLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: LetterTemplateLibraryModule });
LetterTemplateLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseLetterTemplateLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            FormsModule,
            EditorModule,
            EditorLibraryModule,
            // FroalaEditorModule.forRoot(),
            // FroalaViewModule.forRoot(),
            DigitalSignatureLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LetterTemplateLibraryModule, { declarations: [LetterTemplateLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        FormsModule,
        EditorModule,
        EditorLibraryModule,
        // FroalaEditorModule.forRoot(),
        // FroalaViewModule.forRoot(),
        DigitalSignatureLibraryModule], exports: [LetterTemplateLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterTemplateLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [LetterTemplateLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    FormsModule,
                    EditorModule,
                    EditorLibraryModule,
                    // FroalaEditorModule.forRoot(),
                    // FroalaViewModule.forRoot(),
                    DigitalSignatureLibraryModule
                ],
                providers: [BaseLetterTemplateLibraryService],
                exports: [LetterTemplateLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of letter-template-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LetterTemplateLibraryComponent, LetterTemplateLibraryModule, LetterTemplateLibraryService };
//# sourceMappingURL=letter-template-library.js.map
